import { SvgIcon, Text } from '@cinch-labs/design-system'
import CinchServicing from './assets/cinchServicing.svg'
import Envelope from './assets/envelope.svg'
import styles from './confirmation-hero.module.css'

interface ConfirmationHeroProps {
  isDirectBooking: boolean
  title: string
  description: string
  subHeading?: string
}

export const ConfirmationHero = ({
  isDirectBooking,
  title,
  description,
  subHeading,
}: ConfirmationHeroProps) => {
  const icon = isDirectBooking ? (
    <SvgIcon name="check-circle" size={40} color="vividViolet" />
  ) : (
    <Envelope className={styles.icon} />
  )

  return (
    <div className={styles.heroWrapper}>
      <div className={styles.headingIcons}>
        <div className={styles.iconWrapper}>{icon}</div>
        <CinchServicing className={styles.logo} />
      </div>
      <div className={styles.headingText}>
        <Text element="h1" fontSize="xl" fontWeight="bold">
          {title}
        </Text>
        <Text fontSize="m" fontWeight="book">
          {description}
        </Text>
      </div>
      {subHeading && (
        <Text className={styles.subHeading} fontSize="s" fontWeight="semibold">
          {subHeading}
        </Text>
      )}
    </div>
  )
}
